import { Link, Typography } from "@mui/material";
import { useState } from "react";

type Props = {
    text: string;
    maxLength: number;
};

export const ReadMoreText = (props: Props) => {
    const { text, maxLength } = props;
    const [isExpanded, setIsExpanded] = useState(false);

    if (text.length <= maxLength) {
        return <Typography>{text}</Typography>;
    }

    return (
        <Typography variant="body2">
            {isExpanded ? text : `${text.substring(0, maxLength)}...`}
            <br />
            <Link
                onClick={() => setIsExpanded(!isExpanded)}
                sx={{ cursor: "pointer" }}
            >
                {isExpanded ? "Read less" : "Read more"}
            </Link>
        </Typography>
    );
};
